import {IController, IModule} from "angular";
import moment from "moment";
import {dersomChangesInneholder} from "../../felles/stoettefunk/angularHjelpemetoder";

export class RelativDatoMedPrintKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
            .component('relativDato', {
                bindings: {
                    dato: '<',
                    setTitle: '@'
                },
                controller: RelativDatoMedPrintKontroller.forInjisering(),
                template: require('./relativDatoMedPrint.html')
            });
    }

    static forInjisering() {
        return [RelativDatoMedPrintKontroller]
    }

    dato; //settes via bindings
    setTitle: 'true' | 'false'; //settes via bindings (undefined tolkes som true)

    title = '';

    $onChanges(endringer: angular.IOnChangesObject): void {
        dersomChangesInneholder(endringer, 'dato', dato => this.initTittel(dato));
    }

    //hjelpemetoder

    private initTittel(dato: Date) {
        if (this.setTitle === 'false') return;
        this.title = moment(dato).format('L');
    }

}

